import { CUSTOM_ROSTER_SELECTION_TYPE, FILE_UPLOAD_RESPONCE } from '@/utils/constants';
import { Vue, Component, Prop } from 'vue-property-decorator';
import { ROSTER_UPLOADS_CONSTANTS } from '@/utils/roster';
import { rosterAPI } from '@/providers/apis/roster/roster';
import moment from 'moment';

@Component({
    name: 'm-roster-data',
    components: {
        'm-roster-details': () => import('@/routers/m-views/m-setup/m-roster-setup/m-roster-details/m-roster-details.vue'),
    },
})

export default class RosterData extends Vue {

    // -------------------------------------------------------------------
    // Properties
    @Prop()
    private rosterData: any;

    private rosterSyncData: any = [];

    private isRosterDetailsPullUp: boolean = false;



    //  Hook

    private mounted() {
        this.rosterSyncData = this.parseErrors();
    }


    // ---------------------------------------------------------------------
    // Actions
    private onClose() {
        this.$emit('onClose');
    }

    private onPullUpClose() {
        this.isRosterDetailsPullUp = false;
    }

    private onSelectRow(data: any, isError: boolean = false) {
        this.isRosterDetailsPullUp = true;
        this.rosterData.showError = isError;
        this.rosterData.activeType = data;
    }

    // ---------------------------------------------------------------------
    // Methods
    private parseErrors() {
        const activeRoster = this.rosterData;
        const statistics: any = [];
        ROSTER_UPLOADS_CONSTANTS.forEach((type) => {
            const totalCounts = activeRoster.totalCounts[type.recordKey];
            const statistic = {
                name: type.name,
                errors: (totalCounts) ? (totalCounts.errorCount) ? totalCounts.errorCount :
                    (totalCounts.error_count) ? totalCounts.error_count : '--' : '--',
                newData: (totalCounts) ? totalCounts.syncCount ? totalCounts.syncCount :
                    totalCounts.sync_count ? totalCounts.sync_count : '--' : '--',
                errorKey: type.errorKey,
                recoredKey: type.recordKey,
            };
            statistics.push(statistic);
        });
        return statistics;
    }
}
